<template>
  <div class="zwx-dialog">
    <el-dialog :class="customClass" :visible.sync="visible" width="60%" @opened="opened()" :title="title"
               @close="close()" @cancel="cancel()" :close-on-click-modal="false" :destroy-on-close="true"
               :append-to-body="appendToBody" :show-close="ifShowClose" :before-close="cancel">
      <zwx-scrollbar-y class="dialog-scrollbar-y">
        <slot />
      </zwx-scrollbar-y>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;" v-if="ifFooter">
        <div>
          <div style="padding-left: 14px;" v-if="pagination">
            <base-pagination :background="false" :parentPage="currentPage" :pageSize="pageSize" :total="total"
                             @currentChange="currentChange" />
          </div>
          <slot name="footer" v-else />
        </div>
        <div style="margin-right: 20px;">
          <el-button class="zwx-button zwx-button-32" v-if="ifCancel" @click="cancel()">{{ cancelText }}</el-button>
          <el-button class="zwx-button zwx-button-32" v-if="ifDetermine" type="primary" @click="determine()"
                      :disabled="ifDetermineDis">{{ determineText }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BaseDialog",
  props: {
    title: { type: String, default: "" },
    currentPage: { type: Number },
    pageSize: { type: Number },
    total: { type: Number },
    pagination: { type: Boolean, default: false },
    customClass: { type: String, default: "" },
    ifFooter: { type: Boolean, default: true },
    ifDetermine: { type: Boolean, default: true },
    ifCancel: { type: Boolean, default: true },
    appendToBody: { type: Boolean, default: false },
    ifShowClose: { type: Boolean, default: true },
    ifDetermineDis: { type: Boolean, default: false },
    determineText: { type: String, default: "确定" },
    cancelText: { type: String, default: "取消" }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    currentChange(currentPage) {
      this.$emit("currentPage", currentPage);
    },
    show(visible) {
      this.visible = visible;
    },
    determine() {
      this.$emit("determine");
    },
    cancel() {
      this.$emit("cancel");
    },
    opened() {
      this.$emit("opened");
    },
    close() {
      this.$emit("close");
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-scrollbar-y .el-scrollbar__wrap {
  max-height: 64vh !important;
}
</style>

